export default {
    template: {
        label: '',
        id: '',
        type: '',
        options: [],
        value: {},
        valid: false
    },
    sources: [],
    numRows: 0,
    valid: true,
    rows: []
}